export default {
  pageCatalogShopId(state) {
    return state.pageCatalogShopId;
  }
};
